"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckboxRequired = exports.StyledCheckboxLabel = exports.StyledCheckboxError = exports.StyledCheckbox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledCheckbox = _styledComponents["default"].div.withConfig({
  displayName: "Checkboxstyles__StyledCheckbox",
  componentId: "sc-w47z6t-0"
})(["", " padding-top:", ";user-select:none;& label{cursor:pointer;}input{", " &:disabled{&:checked + .checkmark:after{", "}& + .checkmark{background-color:var(--mid-gray);border:1px solid var(--", ");&:after{border-color:var(--mid-gray);}}& ~ label{cursor:not-allowed;color:var(--gray);}}&:not(:disabled):checked ~ .checkmark{background-color:var(--", ");border-width:", ";border-style:solid;border-color:var(--", ");}}&:hover input:not(:disabled):not(:checked) ~ .checkmark{background-color:var(--", ");&:after{border-color:var(--", ");}}.checkmark{", " height:", ";width:", ";border-radius:", ";border-style:solid;border-color:var(--", ");border-width:", ";&:after{", " content:'';", " border-style:solid;border-width:0 2px 2px 0;transform:rotate(45deg);}}"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["flex flex-wrap items-scenter relative f6 mb3"]))), function (_ref) {
  var theme = _ref.theme;
  return theme.checkbox.textTopOffset;
}, (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["absolute o-0"]))), (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["b--dark-gray"]))), function (_ref2) {
  var theme = _ref2.theme;
  return theme.checkbox.checkboxColorDisabled;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.checkbox.checkboxColorChecked;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.checkbox.checkboxBorderWidth;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.checkbox.checkboxColorChecked;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.checkbox.checkboxColorHover;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.checkbox.checkboxColorHover;
}, (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["absolute top-0 left-0 bg-white ml0"]))), function (_ref8) {
  var theme = _ref8.theme;
  return theme.checkbox.checkboxSize;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.checkbox.checkboxSize;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.checkbox.checkboxBorderRadius;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.checkbox.checkboxBorderColor;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.checkbox.checkboxBorderWidth;
}, (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["b--white absolute db"]))), (0, _styledComponents.css)(["", ""], function (_ref13) {
  var theme = _ref13.theme;
  return theme.checkbox.checkmarkPosition;
}));

exports.StyledCheckbox = StyledCheckbox;

var StyledCheckboxError = _styledComponents["default"].div.withConfig({
  displayName: "Checkboxstyles__StyledCheckboxError",
  componentId: "sc-w47z6t-1"
})(["", ""], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["sans-serif w-100 red f7 pt1"]))));

exports.StyledCheckboxError = StyledCheckboxError;

var StyledCheckboxLabel = _styledComponents["default"].label.withConfig({
  displayName: "Checkboxstyles__StyledCheckboxLabel",
  componentId: "sc-w47z6t-2"
})(["", " padding-left:", ";font-size:", ";"], (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["relative"]))), function (_ref14) {
  var theme = _ref14.theme;
  return theme.checkbox.textLeftOffset;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.checkbox.fontSize || '.875rem';
});

exports.StyledCheckboxLabel = StyledCheckboxLabel;

var StyledCheckboxRequired = _styledComponents["default"].span.withConfig({
  displayName: "Checkboxstyles__StyledCheckboxRequired",
  componentId: "sc-w47z6t-3"
})(["", " text-indent:0.15rem;"], (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["red"]))));

exports.StyledCheckboxRequired = StyledCheckboxRequired;